/* Wellbell Lux (r6): reveals, hero parallax, mobile gallery dots, sticky/pill sync, massage-to-reveal gift. Own code. */
(function () {
  'use strict';
  var RM = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* 1. Staggered scroll reveals: only items that start below the fold, so nothing visible on load moves (no CLS). */
  function reveals() {
    if (RM || !('IntersectionObserver' in window)) return;
    var groups = ['.wb-steps__list > *', '.wb-tiles > li', '.wb-coupons > li', '.wb-compare__card', '.wb-head', '.wb-ticks > li', '.wb-step'];
    var vh = window.innerHeight;
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    groups.forEach(function (sel) {
      var seen = {};
      $$(sel).forEach(function (el) {
        if (el.classList.contains('wb-rv') || el.getBoundingClientRect().top < vh) return;
        var p = el.parentNode, k = seen.p === p ? (seen.i = seen.i + 1) : (seen = { p: p, i: 0 }).i;
        el.style.setProperty('--wb-i', Math.min(k, 5));
        el.classList.add('wb-rv'); io.observe(el);
      });
    });
  }

  /* 2. Parallax-lite on the first hero image (transform only, rAF, paused off-screen). */
  function parallax() {
    if (RM) return;
    var img = $('.wb-hero .wb-hero__img'); if (!img) return;
    var hero = img.closest('.wb-hero'); img.classList.add('wb-plx');
    var on = true, ticking = false;
    new IntersectionObserver(function (es) { on = es[0].isIntersecting; }).observe(hero);
    window.addEventListener('scroll', function () {
      if (!on || ticking) return; ticking = true;
      requestAnimationFrame(function () { img.style.setProperty('--wb-plx', (Math.min(window.scrollY, 900) * 0.18).toFixed(1) + 'px'); ticking = false; });
    }, { passive: true });
  }

  /* 3. Mobile gallery dots (44px tap targets) synced with the native swipe slider. */
  function dots() {
    $$('.product__media-list.slider').forEach(function (list) {
      var slides = $$(':scope > .product__media-item', list);
      if (slides.length < 2 || list.dataset.wbDots) return;
      list.dataset.wbDots = '1';
      var nav = document.createElement('div'); nav.className = 'wb-dots'; nav.setAttribute('aria-label', 'Choose image');
      slides.forEach(function (s, i) {
        var b = document.createElement('button'); b.type = 'button'; b.setAttribute('aria-label', 'Image ' + (i + 1) + ' of ' + slides.length);
        b.addEventListener('click', function () { list.scrollTo({ left: s.offsetLeft - list.offsetLeft, behavior: RM ? 'auto' : 'smooth' }); });
        nav.appendChild(b);
      });
      list.parentNode.insertBefore(nav, list.nextSibling);
      var set = function () {
        var i = Math.round(list.scrollLeft / Math.max(1, list.clientWidth));
        $$('button', nav).forEach(function (b, j) { b.setAttribute('aria-current', j === i ? 'true' : 'false'); });
      };
      list.addEventListener('scroll', function () { requestAnimationFrame(set); }, { passive: true });
      set();
    });
  }

  /* 4. Sticky bar state -> body class + height var (pill sits above it). */
  function stickySync() {
    var bar = $('[data-wb-sticky]'); if (!bar) return;
    var upd = function () {
      var on = bar.classList.contains('is-visible');
      document.body.classList.toggle('wb-sticky-on', on);
      if (on) document.documentElement.style.setProperty('--wb-sticky-h', bar.offsetHeight + 'px');
    };
    new MutationObserver(upd).observe(bar, { attributes: true, attributeFilter: ['class'] }); upd();
  }

  /* 5. Massage-to-reveal first-order gift (r7: photo scene). Also drives the buy-box "reserved" strip + pill from the same timer. */
  function gift() {
    var root = $('#wb-mr'); if (!root) return;
    document.body.appendChild(root);
    var pill = $('[data-wb-pill]'); if (pill) document.body.appendChild(pill);
    var KEY = 'wb_mr_v1', code = (root.dataset.code || '').trim().toUpperCase(), pct = +root.dataset.pct || 10;
    var delay = (+root.dataset.delay || 10) * 1000, hours = +root.dataset.hours || 24;
    var st = {}; try { st = JSON.parse(localStorage.getItem(KEY)) || {}; } catch (e) {}
    var save = function () { try { localStorage.setItem(KEY, JSON.stringify(st)); } catch (e) {} };
    var now = function () { return Date.now(); };
    var active = function () { return st.exp && now() < st.exp; };
    var fmt = function (ms) { var s = Math.max(0, Math.floor(ms / 1000)); var p = function (n) { return (n < 10 ? '0' : '') + n; }; return p(Math.floor(s / 3600)) + ':' + p(Math.floor(s / 60) % 60) + ':' + p(s % 60); };
    var rupee = function (paise) { return '\u20B9' + Math.round(paise / 100).toLocaleString('en-IN'); };
    var leftEls = $$('[data-wb-mr-left]', root), pillT = pill && $('[data-wb-pill-left]', pill), timerP = $('[data-wb-mr-timer]', root);
    var tickId = null, html = document.documentElement;

    /* Buy-box strip: same timer source; price hint only where it is verifiably accurate (single bottle, code applies to the unit price). */
    var strips = $$('[data-wb-offer]');
    strips.forEach(function (sp) {
      $$('[data-wb-offer-pct]', sp).forEach(function (el) { el.textContent = pct; });
      var unit = parseInt(sp.dataset.wbUnit, 10), hint = $('[data-wb-offer-hint]', sp);
      var sec = sp.closest('.shopify-section') || document, q = sec.querySelector('input[name="quantity"]');
      var render = function () {
        var n = Math.max(1, parseInt(q && q.value, 10) || 1);
        if (unit && n === 1) { hint.innerHTML = 'Your price: <strong>' + rupee(unit - Math.round(unit * pct / 100)) + '</strong> with ' + code; }
        else { hint.textContent = 'Applied at checkout with ' + code; }
      };
      if (q) { q.addEventListener('change', render); q.addEventListener('input', render); }
      render();
    });
    var stripLeft = $$('[data-wb-offer-left]');

    function tick() {
      if (!st.exp) return;
      var left = st.exp - now();
      if (left <= 0) {             /* honest expiry: hide timer, strip + pill, stop auto-applying */
        st.expired = true; save(); clearInterval(tickId); html.classList.remove('wb-offer-on');
        if (pill) pill.hidden = true; if (timerP) timerP.hidden = true; return;
      }
      var t = fmt(left);
      html.classList.add('wb-offer-on');
      leftEls.forEach(function (el) { el.textContent = t; });
      stripLeft.forEach(function (el) { el.textContent = t; });
      if (pillT) pillT.textContent = t;
      if (pill) pill.hidden = !root.hidden;
    }
    function startTimer() { tick(); clearInterval(tickId); tickId = setInterval(tick, 1000); }

    /* Apply the real code to the cart (only if the cart carries no other code). */
    var applying = false;
    function ensureApplied(statusEl) {
      if (!active() || applying) return Promise.resolve();
      applying = true;
      return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (cart) {
        var codes = (cart.discount_codes || []).map(function (c) { return String(c.code).toUpperCase(); });
        if (codes.indexOf(code) > -1) return cart;
        if (codes.length) return cart;
        return fetch('/discount/' + encodeURIComponent(code) + '?redirect=%2Fcart.js', { credentials: 'same-origin' })
          .then(function () { return cart.item_count ? fetch('/cart/update.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ discount: code }) }).then(function (r) { return r.json(); }) : cart; });
      }).then(function (cart) {
        if (statusEl && cart) {
          var hit = (cart.discount_codes || []).filter(function (c) { return String(c.code).toUpperCase() === code; })[0];
          if (cart.item_count && !hit) statusEl.textContent = 'use code ' + code + ' at checkout';
        }
        html.dataset.wbGift = 'applied';
      }).catch(function () { if (statusEl) statusEl.textContent = 'use code ' + code + ' at checkout'; })
        .then(function () { applying = false; });
    }
    var watching = false;
    function watchCart() {
      if (watching) return; watching = true;
      try { if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') subscribe(PUB_SUB_EVENTS.cartUpdate, function () { setTimeout(ensureApplied, 300); }); } catch (e) {}
    }

    /* Scene elements */
    var scene = $('[data-wb-mr-pad]', root), ring = $('[data-wb-mr-ring]', root), img = $('[data-wb-mr-img]', root);
    var cv = $('[data-wb-mr-trail]', root), ctx = cv.getContext('2d'), bk = $('[data-wb-mr-bokeh]', root), bctx = bk.getContext('2d');
    var prog = $('[data-wb-mr-prog]', root), countEl = $('[data-wb-mr-count]', root);
    var CIRC = 628.3, TURN = Math.PI * 2, NEED = 2, dpr = Math.min(2, window.devicePixelRatio || 1);
    function loadImg() {
      if (!img || img.dataset.go) return; img.dataset.go = '1';
      var done = function () { img.classList.add('is-loaded'); };
      img.loading = 'eager'; if (img.complete && img.naturalWidth) done(); else img.addEventListener('load', done, { once: true });
    }
    function sizeCanvas() {
      var r = scene.getBoundingClientRect();
      [cv, bk].forEach(function (c) { c.width = Math.round(r.width * dpr); c.height = Math.round(r.height * dpr); });
    }
    /* Navel centre + circle radius, measured from the ring (CSS keeps it on the navel: object-position == ring position). */
    function geo() {
      var s = scene.getBoundingClientRect(), g = ring.getBoundingClientRect();
      return { x: g.left + g.width / 2, y: g.top + g.height / 2, r: g.width * 100 / 240, s: s };
    }

    /* Bokeh: soft warm particles drifting at the edges (screen-blended canvas). */
    var bokehRAF = null, parts = [];
    function bokehStart() {
      if (RM || bokehRAF) return;
      var W = bk.width, H = bk.height; parts = [];
      for (var i = 0; i < 22; i++) {
        var edge = Math.random() < .5 ? Math.random() * .28 : .72 + Math.random() * .28;
        parts.push({ x: (i % 2 ? edge : Math.random()) * W, y: Math.random() * H, r: (6 + Math.random() * 26) * dpr, a: .05 + Math.random() * .16,
          vx: (Math.random() - .5) * .12 * dpr, vy: -(.05 + Math.random() * .22) * dpr, ph: Math.random() * TURN });
      }
      (function f(t) {
        bctx.clearRect(0, 0, W, H);
        parts.forEach(function (p) {
          p.x += p.vx; p.y += p.vy; if (p.y < -p.r) { p.y = H + p.r; p.x = Math.random() * W; }
          var a = p.a * (.6 + .4 * Math.sin(t / 1400 + p.ph));
          var g = bctx.createRadialGradient(p.x, p.y, 0, p.x, p.y, p.r);
          g.addColorStop(0, 'rgba(255,214,150,' + a.toFixed(3) + ')'); g.addColorStop(.6, 'rgba(255,190,110,' + (a * .45).toFixed(3) + ')'); g.addColorStop(1, 'rgba(255,190,110,0)');
          bctx.fillStyle = g; bctx.beginPath(); bctx.arc(p.x, p.y, p.r, 0, TURN); bctx.fill();
        });
        bokehRAF = requestAnimationFrame(f);
      })(0);
    }
    function bokehStop() { cancelAnimationFrame(bokehRAF); bokehRAF = null; }

    /* Open / close */
    var lastFocus = null;
    function open() {
      st.seen = now(); save(); loadImg();
      lastFocus = document.activeElement;
      root.hidden = false; html.classList.add('wb-mr-open');
      sizeCanvas(); bokehStart(); var x = $('.wb-mr__x', root); x && x.focus({ preventScroll: true });
    }
    function close() {
      root.hidden = true; html.classList.remove('wb-mr-open'); bokehStop();
      if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
      if (active()) tick();
    }
    $$('[data-wb-mr-close]', root).forEach(function (b) { b.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !root.hidden) close(); });
    root.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab') return;
      var f = $$('button:not([hidden]), a[href]', root).filter(function (el) { return el.offsetParent !== null; });
      if (!f.length) return; var a = f[0], z = f[f.length - 1];
      if (e.shiftKey && document.activeElement === a) { e.preventDefault(); z.focus(); } else if (!e.shiftKey && document.activeElement === z) { e.preventDefault(); a.focus(); }
    });

    /* Gesture: accumulate signed angle around the navel; 2 full turns reveal. Glossy golden oil trail with a fading tail. */
    var drawing = false, last = null, total = 0, pts = [], raf = null, done = false, TAIL = 1400;
    function angleOf(e, c) { return Math.atan2(e.clientY - c.y, e.clientX - c.x); }
    function addPt(e, c) { pts.push({ x: (e.clientX - c.s.left) * dpr, y: (e.clientY - c.s.top) * dpr, t: now() }); if (!raf) raf = requestAnimationFrame(draw); }
    function stroke(i, w, col, blur, dy) {
      ctx.lineWidth = w * dpr; ctx.strokeStyle = col; ctx.shadowBlur = blur * dpr; ctx.beginPath();
      ctx.moveTo(pts[i - 1].x, pts[i - 1].y + dy * dpr); ctx.lineTo(pts[i].x, pts[i].y + dy * dpr); ctx.stroke();
    }
    function draw() {
      var t = now(); ctx.clearRect(0, 0, cv.width, cv.height);
      pts = pts.filter(function (p) { return t - p.t < TAIL; });
      ctx.lineCap = 'round'; ctx.lineJoin = 'round';
      for (var i = 1; i < pts.length; i++) {
        var a = Math.pow(1 - (t - pts[i].t) / TAIL, 1.3);
        ctx.shadowColor = 'rgba(242,183,5,' + (.75 * a).toFixed(3) + ')';
        stroke(i, 26 * (.55 + .45 * a), 'rgba(214,150,0,' + (.24 * a).toFixed(3) + ')', 26, 0);   /* soft oil spread */
        stroke(i, 10 * (.5 + .5 * a), 'rgba(242,183,5,' + (.9 * a).toFixed(3) + ')', 10, 0);     /* golden body */
        ctx.shadowBlur = 0;
        stroke(i, 3, 'rgba(255,248,226,' + (.85 * a).toFixed(3) + ')', 0, -2);                      /* gloss highlight */
      }
      if (pts.length) { var h = pts[pts.length - 1]; ctx.shadowColor = 'rgba(242,183,5,.9)'; ctx.shadowBlur = 22 * dpr; ctx.fillStyle = 'rgba(255,244,200,.97)'; ctx.beginPath(); ctx.arc(h.x, h.y, 7 * dpr, 0, TURN); ctx.fill(); ctx.shadowBlur = 0; }
      raf = (pts.length || drawing) ? requestAnimationFrame(draw) : null;
    }
    function setProgress() {
      var p = Math.min(1, Math.abs(total) / (TURN * NEED));
      prog.setAttribute('stroke-dashoffset', (CIRC * (1 - p)).toFixed(1));
      var n = Math.min(NEED, Math.floor(Math.abs(total) / TURN));
      countEl.textContent = n === 0 ? 'Keep going\u2026 circle 1 of 2' : (n === 1 ? 'Lovely. One more circle' : 'Revealing\u2026');
      if (p >= 1) reveal();
    }
    scene.addEventListener('pointerdown', function (e) {
      if (done) return; drawing = true; root.classList.add('is-tracing');
      try { scene.setPointerCapture(e.pointerId); } catch (x) {}
      var c = geo(); last = angleOf(e, c); addPt(e, c); e.preventDefault();
    });
    scene.addEventListener('pointermove', function (e) {
      if (!drawing || done) return;
      var c = geo(), dx = e.clientX - c.x, dy = e.clientY - c.y;
      addPt(e, c);
      if (Math.sqrt(dx * dx + dy * dy) < c.r * 0.18) return;   /* ignore jitter right on the navel */
      var a = angleOf(e, c), d = a - last;
      if (d > Math.PI) d -= TURN; else if (d < -Math.PI) d += TURN;
      total += d; last = a; setProgress();
    });
    ['pointerup', 'pointercancel', 'lostpointercapture'].forEach(function (ev) { scene.addEventListener(ev, function () { drawing = false; }); });
    $('[data-wb-mr-reveal]', root).addEventListener('click', reveal);

    /* Reveal: skin glows, oil ring blooms, gold confetti, then the 10% card. */
    function reveal() {
      if (done) return; done = true; drawing = false;
      st.rev = now(); st.exp = st.rev + hours * 3600 * 1000; st.expired = false; save();
      prog.setAttribute('stroke-dashoffset', '0');
      root.classList.add('is-bloom', 'is-revealed');
      setTimeout(function () { confetti($('[data-wb-mr-confetti]', root)); }, RM ? 0 : 380);
      setTimeout(function () {
        $('[data-wb-mr-stage="trace"]', root).hidden = true;
        $('[data-wb-mr-stage="gift"]', root).hidden = false;
        root.classList.add('is-gift');
        var shop = $('[data-wb-mr-shop]', root); shop && shop.focus({ preventScroll: true });
      }, RM ? 0 : 1100);
      startTimer(); ensureApplied($('[data-wb-mr-status]', root)); watchCart();
    }

    function confetti(c) {
      if (RM || !c) return;
      var s = c.getBoundingClientRect(), g = geo(), x = c.getContext('2d'); c.width = s.width * dpr; c.height = s.height * dpr;
      var ox = (g.x - s.left) * dpr, oy = (g.y - s.top) * dpr;
      var cols = ['#F2B705', '#FFD23F', '#FFF1B8', '#5A3820', '#8A5A00', '#FFFFFF'], P = [];
      for (var i = 0; i < 150; i++) { var a = Math.random() * TURN, v = (3 + Math.random() * 10) * dpr; P.push({ x: ox, y: oy, vx: Math.cos(a) * v, vy: Math.sin(a) * v - 5 * dpr, s: (2.5 + Math.random() * 5) * dpr, c: cols[i % cols.length], r: Math.random() * TURN, k: i % 3 }); }
      var t0 = now();
      (function f() {
        var k = (now() - t0) / 2200; x.clearRect(0, 0, c.width, c.height); if (k >= 1) return;
        P.forEach(function (p) {
          p.vy += 0.2 * dpr; p.vx *= 0.985; p.vy *= .995; p.x += p.vx; p.y += p.vy; p.r += 0.14;
          x.globalAlpha = Math.max(0, 1 - k * 1.05); x.fillStyle = p.c; x.shadowColor = 'rgba(242,183,5,.8)'; x.shadowBlur = p.k === 2 ? 8 * dpr : 0;
          x.save(); x.translate(p.x, p.y); x.rotate(p.r);
          if (p.k === 0) x.fillRect(-p.s / 2, -p.s / 4, p.s, p.s / 2);
          else { x.beginPath(); x.arc(0, 0, p.s * (p.k === 2 ? .35 : .55), 0, TURN); x.fill(); }
          x.restore();
        });
        requestAnimationFrame(f);
      })();
    }

    /* Boot */
    if (active()) { startTimer(); ensureApplied(); watchCart(); }
    else { html.classList.remove('wb-offer-on'); if (st.exp && !st.expired) { st.expired = true; save(); } }
    if (!st.seen && !st.rev && !/^\/(cart|checkout)/.test(location.pathname)) {
      setTimeout(loadImg, Math.max(0, delay - 3000));
      setTimeout(function () { if (!st.seen && document.visibilityState !== 'hidden') open(); else if (!st.seen) document.addEventListener('visibilitychange', function v() { if (document.visibilityState === 'visible') { document.removeEventListener('visibilitychange', v); open(); } }); }, delay);
    }
    window.addEventListener('resize', function () { if (!root.hidden) sizeCanvas(); });
  }

  function init() { reveals(); parallax(); dots(); stickySync(); gift(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
